import { render, staticRenderFns } from "./LiquidationSubmissionInvoiceTab.vue?vue&type=template&id=b23a3c1a&scoped=true&lang=pug"
import script from "./LiquidationSubmissionInvoiceTab.vue?vue&type=script&lang=js"
export * from "./LiquidationSubmissionInvoiceTab.vue?vue&type=script&lang=js"
import style0 from "./LiquidationSubmissionInvoiceTab.vue?vue&type=style&index=0&id=b23a3c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23a3c1a",
  null
  
)

export default component.exports